/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Input, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";

import { ObjectService } from "app/services/object.service";
import { ObjectCategory } from "../models/object-category";
import { ObjectProperty } from "app/models/object-property";

/**
 * Obtains the Properties that have been marked as Main Display (main display = TRUE)
 * for all People Types and returns them.  Currently being used for loading the Properties
 * available to search people by in the "Monitor Zone" page. 
 */
@Injectable()
export class PeoplePropertiesMainDisplayResolver implements Resolve<ObjectProperty[]> {

  /**
   * Constructor
   */
  constructor(
    private objectService: ObjectService
  ) {}

  /**
   * Resolves the route, returning the data that should be available to the component on 
   * initialization. In this case, it returns a Promise of the Main Display Properties for
   * all People Types.
   */
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ObjectProperty[]> {
    return this.objectService.getAllPropertiesForMainDisplayAndCategory(ObjectCategory.PEOPLE);
  }

}
